// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xESk","col":"styles_col__Hfj70"};